import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";
import TestsRequests from "services/tests";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

export default function AddWordDialog({ open, handleClose }) {
  const [word, setWord] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");

  const { activeWGEvent } = useSelector(({ events }) => events);

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleAddUserAccess = () => {
    dispatch(
      TestsRequests.addWord({
        word: word,
        eventId: selectedEvent,
      })
    );
    handleClose();
    reset();
  };

  const reset = () => {
    setWord("");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-word"
      aria-describedby="alert-add-word"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-word">
          اضافه کردن کلمه
        </DialogContentText>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12} className={classes.inputContainer}>
            <Typography>کلمه مورد نظر</Typography>
            <TextField
              id="WordInput"
              label="کلمه"
              type="text"
              variant="outlined"
              className={classes.customInput}
              value={word}
              onChange={(e) => setWord(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} className={classes.inputContainer}>
            {activeWGEvent.length === 0 ? (
              <Typography style={{ color: "red", marginBottom: 10 }}>
                لطفا ابتدا یک رویداد فعال ایجاد کنید
              </Typography>
            ) : (
              <FormControl variant="outlined" style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-outlined-label">
                  رویداد
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  value={selectedEvent}
                  onChange={(e) => setSelectedEvent(e.target.value)}
                  label="event"
                >
                  {activeWGEvent.map((item) => (
                    <MenuItem value={item._id}>{item.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddUserAccess} color="primary">
          اضافه کردن
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
}
